import { render, staticRenderFns } from "./UserRegister.vue?vue&type=template&id=65d5f3d2"
import script from "./UserRegister.vue?vue&type=script&lang=ts"
export * from "./UserRegister.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports